import React, { useState, useEffect } from "react";
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow from "./../../img/arrow.png";

const VideoCard = ({ video }) => {
  const [playing, setPlaying] = useState(false);
  const videoId = video.id.videoId;
  const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <div
      style={{
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        padding: "10px",
        width:"100%"
      }}
    >
      {playing ? (
        <iframe
          width="100%"
          height="350"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&origin=https://makkaan.com`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={video.snippet.title}
        />
      ) : (
        <div
          onClick={() => setPlaying(true)}
          style={{
            position: "relative",
            cursor: "pointer",
            borderRadius: "8px",
            overflow: "hidden",
            height: "350px",
          }}
        >
          <img
            src={thumbnail}
            alt={video.snippet.title}
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
          {/* Play button overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0,0,0,0.25)",
            }}
          >
            <div
              style={{
                width: "54px",
                height: "54px",
                borderRadius: "50%",
                background: "#FF0000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: "10px solid transparent",
                  borderBottom: "10px solid transparent",
                  borderLeft: "18px solid white",
                  marginLeft: "4px",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const YoutubeVideo = () => {
  const [videos, setVideos] = useState([]);
  const API_KEY = "AIzaSyBqjH4WMRAjhsU-mtQjaDvx4BU2yEB2Qbc";
  const CHANNEL_ID = "UC4iIjbDmUjRhOk4ehLFkwaw";

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=6`
        );
        setVideos(response.data.items);
      } catch (error) {
        console.error("Error fetching videos", error);
      }
    };

    fetchVideos();
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 375, min: 0 },
      items: 2,
    },
  };

  return (
    <div className="container">
      <div>
        <div className="text-center mb-4">
          <h2 style={{ fontWeight: "600", fontSize: "24px", lineHeight: "28.8px" }}>
            MAKKAAN YOUTUBE
          </h2>
          <img src={arrow} alt="arrow" />
        </div>
        <Carousel
          responsive={responsive}
          autoPlay={true}
          autoPlaySpeed={2000}
          infinite={true}
        >
          {videos.map((video) => (
            <VideoCard key={video.id.videoId} video={video} />
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default YoutubeVideo;
